var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgMarketplaceIcon(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.714 5.484c.295-2.288 1.838-3.784 3.4-3.784 1.564 0 3.11 1.497 3.401 3.784h-6.8zm-1.71 0C7.312 2.544 9.338 0 12.115 0c2.775 0 4.808 2.541 5.11 5.484h1.69c.825 0 1.612.337 2.19.93.575.59.895 1.388.895 2.215v7.725c0 2.021-.782 3.964-2.18 5.4A7.38 7.38 0 0114.532 24H9.467c-.984 0-1.957-.199-2.865-.585a7.46 7.46 0 01-2.423-1.663 7.664 7.664 0 01-1.614-2.48A7.808 7.808 0 012 16.352V8.629c0-.41.079-.816.232-1.196a3.15 3.15 0 01.664-1.02 3.055 3.055 0 012.189-.93h1.92zm-2.89 2.115c.261-.269.611-.415.971-.415h13.829c.36 0 .71.146.971.415.262.27.414.64.414 1.03v7.725c0 1.585-.613 3.1-1.698 4.213a5.68 5.68 0 01-4.07 1.734H9.467a5.615 5.615 0 01-2.2-.45 5.757 5.757 0 01-1.87-1.284 5.963 5.963 0 01-1.255-1.93 6.108 6.108 0 01-.442-2.284V8.63a1.5 1.5 0 01.108-.56 1.45 1.45 0 01.306-.47zm.82 3.093c0-.47.38-.85.85-.85h12.487a.85.85 0 110 1.7H5.784a.85.85 0 01-.85-.85zm.85 2.656a.85.85 0 100 1.7h12.487a.85.85 0 100-1.7H5.784z",
    fill: "#B9BBC6"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgMarketplaceIcon;